import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";

const AppDialog = ({ open, onClose, children, padded = true, ...rest }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="auth-dialog"
      sx={{
        ".MuiBackdrop-root": {
          backgroundColor: "rgba(8, 21, 43, 0.52)",
        },
        ".MuiPaper-root": {
          width: { xs: "92%", sm: "480px" },
          maxWidth: "520px",
          maxHeight: "90vh",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 28px 64px rgba(8, 21, 43, 0.24)",
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          outline: "none",
          maxHeight: "90vh",
          overflow: "auto",
          p: padded ? { xs: 2.5, sm: 3.5 } : 0,
          "&:focus": { outline: "none" },
        }}
        {...rest}
      >
        {children}
      </Box>
    </Dialog>
  );
};

export default AppDialog;
